import {  apiGet } from 'utils/API/actions/request'
import { CONTACT } from '../constants'

export const fetchContact = (appid) => apiGet({
  entity: CONTACT,
  url: `/contactinfo/${appid}`,
}) 
